import React from 'react';
import { Phone, Mail, Star } from 'lucide-react';
import { EnPowerLogoText } from '../../../EnPowerLogo';
import { colors, fonts, space } from '../../tokens';
import { DraggableElement } from '../../../DraggableElement';
import { InlineEditableText } from '../../../InlineEditableText';

/**
 * CTASection – Call-to-Action + SignatureFooter am Ende von Page 4.
 * Enthält CTAHeadline, CTASubtext, ContactInfo und Signatur.
 */
export const CTASection = ({ ansprechpartner, telefon, email, gueltigBis, content = {}, onTextChange, editMode = false, layoutEditLevel = 'section', dragProps = {} }) => {
  const ctaText = {
    badge: content?.badge || 'Bereit für den nächsten Schritt?',
    headline: content?.headline || 'Lassen Sie uns sprechen.',
    sublinePrefix: content?.sublinePrefix || 'Ich freue mich auf Ihre Rückmeldung -',
    signatureLead: content?.signatureLead || 'Mit freundlichen Grüßen,',
    validUntilLabel: content?.validUntilLabel || 'Gültig bis',
  };

  return (
  <>
    {/* CTA Banner */}
    {layoutEditLevel === 'detail' ? (
      <DraggableElement id="S4-CTA-Banner" {...dragProps} dragAxis="y">
        <div
          style={{
            margin: `${space.md}px ${space.xxl}px 0`,
            background: colors.navy,
            borderRadius: '10px',
            padding: `${space.md}px 20px`,
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: '20px',
            alignItems: 'center',
            flexShrink: 0,
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '4px' }}>
              <Star size={11} color={colors.orange} fill={colors.orange} />
              <p style={{ fontFamily: fonts.body, fontSize: '7.5px', fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.1em', margin: 0 }}>
                <InlineEditableText as="span" value={ctaText.badge} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.badge', value)} />
              </p>
            </div>
            <p style={{ fontFamily: fonts.display, fontSize: '14px', fontWeight: 700, color: 'white', marginBottom: '3px' }}>
              <InlineEditableText as="span" value={ctaText.headline} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.headline', value)} />
            </p>
            <p style={{ fontFamily: fonts.body, fontSize: '9px', color: 'rgba(255,255,255,0.55)', margin: 0 }}>
              <InlineEditableText as="span" value={ctaText.sublinePrefix} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.sublinePrefix', value)} />{' '}
              <span style={{ color: 'white', fontWeight: 600 }}>{ansprechpartner}</span>
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '20px', height: '20px', background: 'rgba(255,255,255,0.1)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Phone size={9} color="white" />
              </div>
              <span style={{ fontFamily: fonts.body, fontSize: '9.5px', color: 'white', fontWeight: 500 }}>{telefon}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '20px', height: '20px', background: 'rgba(224,112,0,0.2)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Mail size={9} color={colors.orange} />
              </div>
              <span style={{ fontFamily: fonts.body, fontSize: '9.5px', color: 'white', fontWeight: 500 }}>{email}</span>
            </div>
          </div>
        </div>
      </DraggableElement>
    ) : (
      <div
        style={{
          margin: `${space.md}px ${space.xxl}px 0`,
          background: colors.navy,
          borderRadius: '10px',
          padding: `${space.md}px 20px`,
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gap: '20px',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '4px' }}>
            <Star size={11} color={colors.orange} fill={colors.orange} />
            <p style={{ fontFamily: fonts.body, fontSize: '7.5px', fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.1em', margin: 0 }}>
              <InlineEditableText as="span" value={ctaText.badge} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.badge', value)} />
            </p>
          </div>
          <p style={{ fontFamily: fonts.display, fontSize: '14px', fontWeight: 700, color: 'white', marginBottom: '3px' }}>
            <InlineEditableText as="span" value={ctaText.headline} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.headline', value)} />
          </p>
          <p style={{ fontFamily: fonts.body, fontSize: '9px', color: 'rgba(255,255,255,0.55)', margin: 0 }}>
            <InlineEditableText as="span" value={ctaText.sublinePrefix} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.sublinePrefix', value)} />{' '}
            <span style={{ color: 'white', fontWeight: 600 }}>{ansprechpartner}</span>
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{ width: '20px', height: '20px', background: 'rgba(255,255,255,0.1)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Phone size={9} color="white" />
            </div>
            <span style={{ fontFamily: fonts.body, fontSize: '9.5px', color: 'white', fontWeight: 500 }}>{telefon}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{ width: '20px', height: '20px', background: 'rgba(224,112,0,0.2)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Mail size={9} color={colors.orange} />
            </div>
            <span style={{ fontFamily: fonts.body, fontSize: '9.5px', color: 'white', fontWeight: 500 }}>{email}</span>
          </div>
        </div>
      </div>
    )}

    {/* SignatureFooter */}
    {layoutEditLevel === 'detail' ? (
      <DraggableElement id="S4-CTA-Signatur" {...dragProps} dragAxis="y">
        <div style={{ margin: `${space.sm + space.xs}px ${space.xxl}px 0`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <p style={{ fontFamily: fonts.body, fontSize: '8.5px', color: colors.slateLight, marginBottom: '2px', fontStyle: 'italic' }}><InlineEditableText as="span" value={ctaText.signatureLead} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.signatureLead', value)} /></p>
            <p style={{ fontFamily: fonts.display, fontSize: '12px', fontWeight: 700, color: colors.navy, marginBottom: '2px' }}>{ansprechpartner}</p>
            <EnPowerLogoText size="sm" variant="dark" />
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ fontFamily: fonts.body, fontSize: '7.5px', color: colors.slateLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '2px' }}><InlineEditableText as="span" value={ctaText.validUntilLabel} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.validUntilLabel', value)} /></p>
            <p style={{ fontFamily: fonts.display, fontSize: '11px', fontWeight: 600, color: colors.navy }}>{gueltigBis}</p>
          </div>
        </div>
      </DraggableElement>
    ) : (
      <div style={{ margin: `${space.sm + space.xs}px ${space.xxl}px 0`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
        <div>
          <p style={{ fontFamily: fonts.body, fontSize: '8.5px', color: colors.slateLight, marginBottom: '2px', fontStyle: 'italic' }}><InlineEditableText as="span" value={ctaText.signatureLead} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.signatureLead', value)} /></p>
          <p style={{ fontFamily: fonts.display, fontSize: '12px', fontWeight: 700, color: colors.navy, marginBottom: '2px' }}>{ansprechpartner}</p>
          <EnPowerLogoText size="sm" variant="dark" />
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={{ fontFamily: fonts.body, fontSize: '7.5px', color: colors.slateLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '2px' }}><InlineEditableText as="span" value={ctaText.validUntilLabel} editable={editMode} onChange={(value) => onTextChange?.('page4.cta.validUntilLabel', value)} /></p>
          <p style={{ fontFamily: fonts.display, fontSize: '11px', fontWeight: 600, color: colors.navy }}>{gueltigBis}</p>
        </div>
      </div>
    )}

    <div style={{ height: '44px', flexShrink: 0 }} />
  </>
  );
};
